import { useState, useEffect, Fragment } from "react"
import packageJason from "../../package.json"
import { DateTime } from "luxon"
const buildDateGreaterThan = (latestDate, currentDate) => {
  const momLatestDateTime = new DateTime(latestDate)
  const momCurrentDateTime = new DateTime(currentDate)

  if (momLatestDateTime > momCurrentDateTime) {
    return true
  } else {
    return false
  }
}

function WithClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false)

    useEffect(() => {
      fetch("/meta.json")
        .then((response) => response.json())
        .then((meta) => {
          const latestVersionDate = meta.buildDate
          const currentVersionDate = packageJason.buildDate

          const shouldForceRefresh = buildDateGreaterThan(
            latestVersionDate,
            currentVersionDate
          )
          if (shouldForceRefresh) {
            setIsLatestBuildDate(false)
            refreshCacheAndReload()
          } else {
            setIsLatestBuildDate(true)
          }
        })
    }, [])

    const refreshCacheAndReload = () => {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then((names) => {
          for (const name of names) {
            caches.delete(name)
          }
        })
      }
      // delete browser cache and hard reload
      window.location.reload(true)
    }

    return (
      <Fragment>{isLatestBuildDate ? <Component {...props} /> : null}</Fragment>
    )
  }

  return ClearCacheComponent
}

export default WithClearCache
